import VueSession from 'vue-session';

function install(Vue, options = {}) {
	Vue.use(VueSession, options.storage);

	Vue.$session = Vue.prototype.$session;
}

export default { install };
